// src/services/categories/categories.services.js
import apiClient from "../../components/ApiClient/apiClient";

export const fetchCategoriesData = async () => {
  try {
    const result = await apiClient.get("web/api/categories/");
    return result.data;
  } catch (error) {
    console.error("Failed to fetch categories:", error);
    throw error;
  }
};
